<template>
  <div class="sokal-modern-styles">
    <div class="hp-content-on-image">
      <div class="bg-image" :style="{backgroundImage: contentImg}">
        <div class="bg-content-on-image sokal-flex sokal-flex-col sokal-items-end sokal-sm-justify-center">
        <h2>MOBILE SERVICE</h2>
        <p>Get oil changes, tire rotations, battery replacements and more right from your door.</p>
        <a class="sokal-btn sokal-btn-primary has-border-radius dark-theme" href="#">
          <div class="sokal-flex sokal-flex-row sokal-items-center sokal-justify-center">
            <span class="sokal-btn-copy">Schedule Now</span>
            <div class="sokal-btn-icon-slot" style="height: 1.6em;"></div>
          </div>
        </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  import "../../static/bootstrap-3.3.7-dist/js/bootstrap.min.js";

  export default {
    props: ['images'],
    computed: {
      contentImg () {
        if (this.brand === 'kia' || this.brand === 'cjdr' || this.brand === 'infiniti') {
          return 'url(' + this.images.lifestyleImages.defaultImage + ')';
        } else if (this.brand === 'none' || this.brand === 'honda') {
          return 'url(' + this.images.lifestyleImages.sedanImage + ')';
        } else if (this.brand === 'chevrolet' || this.brand === 'nissan' || this.brand === 'ford') {
          return 'url(' + this.images.lifestyleImages.truckImage + ')';
        } else {
          return 'url(' + this.images.lifestyleImages.suvImage + ')';
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '@/assets/styles/sokal-utility-classes.scss';
  @import '@/assets/styles/sokal-modern-styles.scss';
  @import '@/assets/styles/modern-utility-classes.scss';
</style>

<style scoped>
  .hp-content-on-image {
    --sokal-has-border-radius-value: 50px;
  }
  .hp-content-on-image .bg-image {
    background-repeat: no-repeat;
    background-size: cover;
    background-position-y: center;
    height: 80vh;
  }

  .hp-content-on-image .bg-content-on-image {
    height: 100%;
    color: #ffffff;
    padding: 2em;
    background: linear-gradient(216deg, #00142ec2 0%, rgba(0, 20, 46, 0) 50%), linear-gradient(317deg, rgba(0, 20, 46, 0.75) 0%, rgba(0, 20, 46, 0) 25%)
  }

  .hp-content-on-image .bg-content-on-image h2 {
    font-family: var(--large-text) !important;
    font-size: 10rem;
    max-width: 50rem;
    line-height: 0.95;
    text-align: end;
  }

  .hp-content-on-image .bg-content-on-image p {
    max-width: 250px;
    text-align: right;
    font-size: 1.75rem;
  }

  .hp-content-on-image .bg-content-on-image .sokal-btn-primaary {
    border-color: #ffffff;
  }

  @media (max-width: 767px) {
    .hp-content-on-image .bg-content-on-image {
      justify-content: end;
      padding: 1em;
    }
    .hp-content-on-image .bg-content-on-image h2 {
      font-size: 10rem;
    }
  }
</style>